import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {PRIMARY_CUSTOMER_SERVICE} from '../../../../constants/contacts';

// import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({});

class Summer2018 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

	render() {
		return <div className='Summer2018'>
			<div className="promoBanner">
				<img src="/summer_landing_header_1.jpg" alt="Diamonds Direct Summer" />
			</div>
			<div className="promoBody">
				<div className="promoText">
					This summer, make Diamonds Direct your destination for diamonds with our in-store exclusive Summer Event. Enjoy:
				</div>
				<div className="promoHighlightSection">
					20% Special Savings
				</div>
				<div className="promoText" style={{margin: '0'}}>
					Internationally renowned designers have curated <span className='light-em'>exclusive collections</span> for each of our stores. Explore our designers in-store for a chance to win exclusive prizes! Visit our locations to learn more!
				</div>
				<div className="summerLocationBlock">
					<div className="summerLocationItem">
						<div className="summerDates">July 13-15</div>
						<div className="summerLocations">
							<a className="holiday-location-link" href="/indianapolis">Indianapolis,&nbsp;IN</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="/oklahoma-city">Oklahoma&nbsp;City,&nbsp;OK</a>
							<br />
							<a className="holiday-location-link" href="/salt-lake-city">Salt&nbsp;Lake&nbsp;City,&nbsp;UT</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="/virginia-beach">Virginia&nbsp;Beach,&nbsp;VA</a>
						</div>
					</div>
					<div className="summerLocationItem">
						<div className="summerDates">July 20-22</div>
						<div className="summerLocations">
							<a className="holiday-location-link" href="/charlotte">Charlotte,&nbsp;NC</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="/dallas">Dallas,&nbsp;TX</a>
							<br />
							<a className="holiday-location-link" href="/richmond">Richmond,&nbsp;VA</a>
						</div>
					</div>
					<div className="summerLocationItem">
						<div className="summerDates">July 27-29</div>
						<div className="summerLocations">
							<a className="holiday-location-link" href="/birmingham">Birmingham,&nbsp;AL</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="/charleston">Charleston,&nbsp;SC</a>
							<br />
							<a className="holiday-location-link" href="/raleigh">Raleigh,&nbsp;NC</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="/sanantonio">San&nbsp;Antonio,&nbsp;TX</a>
						</div>
					</div>
					<div className="summerLocationItem">
						<div className="summerDates">August 3-5</div>
						<div className="summerLocations">
							<a className="holiday-location-link" href="/austin">Austin,&nbsp;TX</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="http://globaldiamondsusa.com">Jacksonville,&nbsp;FL</a>
							<br />
							<a className="holiday-location-link" href="/st-louis">St.&nbsp;Louis,&nbsp;MO</a>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}
}
export default Summer2018;

function mapStateToProps(state) {
  return {

  };
}

export const Summer2018Container = connect(
  mapStateToProps,
  allActionCreators
)(Summer2018);


// WEBPACK FOOTER //
// ./src/components/views/promopages/summer2018/Summer2018.jsx